import { styled, Chip } from '@mui/material';

export const OrderReceivedStateChipRoot = styled(Chip)(({ theme }) => ({
  minWidth: 146,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase',
}));
